import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Button } from "../core/components/button";
import { DialogHelper } from "../core/util/dialogHelper";
import { ImageDocument, ImageDocumentField } from "../core/components/imageDocument";
import { Config } from "../core/config/config";
import { ResourceAppProps } from "./resource";
import React from "react";
export interface MobileClientAppProps extends ResourceAppProps {
    handleFieldChange?: (field, value) => void;
}

export default class MobileClient extends React.Component<MobileClientAppProps, {
    mobileClientViewModel: MobileClientViewModel;
}> {
    private _isQrCodeHovered = false;

    constructor(props) {
        super(props);
        this.state = {
            mobileClientViewModel: null
        }
    }

    componentDidMount() {
        this.init();
    }

    private init = async (actionAfterInit: () => void = null) => {
        let dataUrl = 'MobileClient/InitMobileClient?ressNr=' + encodeURIComponent(this.props.entity.Ressnr);

        if (this.state.mobileClientViewModel?.UseExtendetLogin && !this.state.mobileClientViewModel?.LoginPrepared) {
            const pw = await DialogHelper.prompt(`
                <div>
                    ${Helper.getTranslation("Login.PleaseEnterYorPassword")}
                    </br></br>
                    <div><i class='fal fa-info-circle'></i> ${Helper.getTranslation("WebSMS.Resource.FieldService.InfoAppUserGeneralSettings")}</div>
                </div>`, '', 500, true);
            if (Helper.isNullOrEmpty(pw))
                return;
            dataUrl = dataUrl + '&password=' + encodeURIComponent(pw);
        }

        const result = await HTTPService.get<JsonResultClass<MobileClientViewModel>>(dataUrl);
        if (result.Code == 0) {
            let mobileClientVm = result.Data;
            this.setState({ mobileClientViewModel: mobileClientVm }, () => {
                if (mobileClientVm.LoginPrepared && Helper.hasValue(actionAfterInit)) {
                    actionAfterInit();
                }
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private executeActionAfterInit = (action: () => void) => {
        if (this.state.mobileClientViewModel?.LoginPrepared)
            action();
        else
            this.init(action);
    }

    private _handleActivate = async () => {
        this.executeActionAfterInit(async () => {
            let result = await HTTPService.post<JsonResultClass<QrCodeViewModel>>("MobileClient/Activate", { ressNr: this.props.entity.Ressnr })
            if (result.Code == 0) {
                this.props.handleFieldChange({model: "Usesapp"}, true);
                this.setStateQrCodeViewModel(result.Data);
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        })
    }

    private _handleDeactivate = async () => {
        this.executeActionAfterInit(async () => {
            if (await DialogHelper.confirm(Helper.getTranslation("WebSMS.Resource.WindowsClientWirklichDeaktivieren"))) {
                let result = await HTTPService.post<JsonResultClass>("MobileClient/Deactivate", { ressNr: this.props.entity.Ressnr });
                if (result.Code == 0) {
                    this.props.handleFieldChange({model: "Usesapp"}, false);
                    this.setState({});
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }
        });
    }

    private _handleReloadQrCode = async () => {
        this.executeActionAfterInit(async () => {
            let result = await HTTPService.get<JsonResultClass<QrCodeViewModel>>("MobileClient/GetQrCode", { ressNr: this.props.entity.Ressnr })
            if (result.Code == 0) {
                this.props.handleFieldChange({model: "Usesapp"}, true);
                this.setStateQrCodeViewModel(result.Data);
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        })
    }

    private setStateQrCodeViewModel = (vm: QrCodeViewModel) => {
        let mobileClientVm = this.state.mobileClientViewModel;
        mobileClientVm.AppQrCodeDocGuid = vm.AppQrCodeDocGuid;
        mobileClientVm.AppQrCodeDocId = vm.AppQrCodeDocId;
        mobileClientVm.AppInitDocGuid = vm.AppInitDocGuid;
        mobileClientVm.AppInitDocId = vm.AppInitDocId;
        this.setState({ mobileClientViewModel: mobileClientVm });
    }

    private _handleDownloadInitFile = async () => {
        this.executeActionAfterInit(async () => {
            if (!this.state.mobileClientViewModel.AppInitDocGuid)
                NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Resource.FieldService.InitFileNotFound"));

            Helper.download(`${Config.baseUrl}Document/Download/${encodeURIComponent(this.state.mobileClientViewModel.AppInitDocGuid) }`, "newFile");
        });
    }

    private _renderAppProfile = (usesApp: boolean) => {
        let status = usesApp ? Helper.getTranslation("Standard.Aktiviert") : Helper.getTranslation("Standard.Deaktiviert");
        let color = usesApp ? "#4caf50" : "#f44336";
        let border = "1px solid " + color;
        let buttonAction = usesApp ? this.renderDeactivateButton() : this.renderActivateButton();
        let buttonRefreshQrCode = usesApp ? this.renderRefreshQrCodeButton() : null;
        let buttonDownloadInitFile = usesApp ? this.renderDownloadInitFileButton() : null;
        return (
            <div style={{ display: "flex", alignItems: "center", margin: "5px", width: "fit-content", flexWrap: "wrap" }}>
                <div style={{ width: "auto" }}>
                    <label>{Helper.getTranslation("WebSMS.Resource.AppProfil")}</label>
                </div>
                <div style={{ height: "38px", display: "flex", alignItems: "center", justifyContent: "center", margin: "5px 3px 3px 3px", padding: "3px", border: border, width: "200px"}} >
                    <label style={{ color: color }}>{status}</label>
                </div>
                <div style={{ marginLeft: "5px" }}>
                    {buttonAction}
                </div>
                <div style={{ marginLeft: "5px" }}>
                    {buttonRefreshQrCode}
                </div>
                <div style={{ marginLeft: "5px" }}>
                    {buttonDownloadInitFile}
                </div>
            </div>
        );
    }

    private _toggleQrCode = (on: boolean) => {
        this._isQrCodeHovered = on;
        this.setState({});
    }

    private renderRefreshQrCodeButton = () => {
        return <Button buttonStyle={{ borderRadius: "var(--border-radius)", width: "fit-content" }} text={Helper.getTranslation("Standard.Aktualisieren")} iconName="refresh" handleClick={this._handleReloadQrCode} readOnly={!this.state.mobileClientViewModel?.CanUseMobileClient}/>
    }

    private renderActivateButton = () => {
        if (!Helper.isNullOrEmpty(this.props.entity.Pwuser_Name)) //&& this.props.handleEval("saveEnabled == false")
            return <Button buttonStyle={{ width: "fit-content" }} text={Helper.getTranslation("Standard.Aktivieren")} iconName="check" handleClick={this._handleActivate} readOnly={!(this.state.mobileClientViewModel?.CanUseMobileClient && this.props.entity.RecordRight.CanWrite)} />
        else
            return <label>{Helper.getTranslation("WebSMS.Resource.ActivationNotPossibleOnlyAppProfile")}</label>
    }

    private renderDeactivateButton = () => {
        return <Button buttonStyle={{ borderRadius: "var(--border-radius)", width: "fit-content" }} text={Helper.getTranslation("Standard.Deaktivieren")} iconName="ban" handleClick={this._handleDeactivate} readOnly={!(this.state.mobileClientViewModel?.CanUseMobileClient && this.props.entity.RecordRight.CanWrite)} />
    }

    private renderDownloadInitFileButton = () => {
        return <Button
            buttonStyle={{ borderRadius: "var(--border-radius)", width: "fit-content" }}
            text={Helper.getTranslation("WebSMS.Resource.FieldService.DownloadInitFile")}
            iconName="download"
            handleClick={this._handleDownloadInitFile}
            readOnly={!(this.state.mobileClientViewModel?.CanUseMobileClient && this.props.entity.RecordRight.CanRead)}
        />
    }

    private _renderAppQrCode = () => {
        let idf: ImageDocumentField = {
            width: "200px",
            readOnlyImage: true,
            type: "",
            model: ""
        };
        return (
            <div style={{ width: "100%", height: "200px", display: "flex" }}>
                <div style={{ width: "100%", position: "relative" }}>
                    <div onMouseEnter={() => this._toggleQrCode(true)} onMouseLeave={() => this._toggleQrCode(false)} style={{ position: "absolute", zIndex: 0, }}>
                        <ImageDocument field={idf} value={this.state.mobileClientViewModel.AppQrCodeDocGuid} />
                    </div>
                    <div onMouseEnter={() => this._toggleQrCode(true)} style={{ display: this._isQrCodeHovered ? "block" : "none", position: "absolute", zIndex: 1, left: "84px", top: "84px" }}>
                        <Button iconName="envelope " handleClick={(e) => {
                            let url = Config.baseUrl +
                                "EmailSender/New?type=resource&itemKey=" + this.props.entity.Ressnr
                                + "&senderName=Innosoft&subject=Mobile Client Invitation&receiver=" + this.props.entity.Vorname + ' ' + this.props.entity.Name + '**' + this.props.entity.Email1
                                + "&documentids=" + this.state.mobileClientViewModel.AppQrCodeDocId + ";" + this.state.mobileClientViewModel.AppInitDocId;
                            Helper.openInNewBrowserTab(url)
                        }} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let canRenderQrCode = Helper.hasValue(this.state.mobileClientViewModel) && Helper.hasValue(this.state.mobileClientViewModel.AppQrCodeDocId) && Helper.hasValue(this.state.mobileClientViewModel.AppQrCodeDocGuid);
        let qrCode = this.props.entity.Usesapp && canRenderQrCode ? this._renderAppQrCode() : null;
        let warningCanUseMobileClient = !this.state.mobileClientViewModel?.CanUseMobileClient ? <label>{Helper.getTranslation("WebSMS.Resource.FieldService.AppServerNotFound")}</label> : null;
        return (
            <div style={{ display: "flex", flexDirection: "column" }} >
                {warningCanUseMobileClient}
                {this._renderAppProfile(this.props.entity.Usesapp)}

                <div style={{ marginTop: "5px", width: "auto", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                    {qrCode}
                </div>
            </div>
        );
    }
}

interface MobileClientViewModel {
    LoginPrepared?: boolean;
    UseExtendetLogin?: boolean;
    AppQrCodeDocGuid?: string;
    AppQrCodeDocId?: number;
    AppInitDocGuid?: string;
    AppInitDocId?: number;
    CanUseMobileClient?: boolean;
}

interface QrCodeViewModel {
    AppQrCodeDocGuid?: string;
    AppQrCodeDocId?: number;
    AppInitDocGuid?: string;
    AppInitDocId?: number;
}